import {
  SET_OFFDAYS_SUCCESS,
  DELETE_OFFDAYS,
  REQUEST_OFFDAYS,
  PUBLISH_OFFDAYS,
  ACCEPT_OFFDAYS,
  DECLINE_OFFDAYS,
  SET_OFFDAYS_FAILURE,
  SET_APPROVEMENT_STATE
} from 'actions/types'

import { setUserOffDays, deleteUserOffDays, requestUserOffDays, publishUserOffDays, acceptUserOffDays, declineUserOffDays, setApprovementState } from '../api'
import { dataFailure, dataSuccess } from './general'

const setOffDaysSuccess = (values) => {
  return {
    type: SET_OFFDAYS_SUCCESS,
    payload: values
  }
}

const setOffDaysFailure = (err) => {
  return {
    type: SET_OFFDAYS_FAILURE,
    payload: err
  }
}

export const setOffDays = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(setUserOffDays(values));
      dispatch(setOffDaysSuccess(JSONData));
      dispatch(dataSuccess())
    } catch(err) {
      dispatch(setOffDaysFailure(err))
      dispatch(dataFailure())
    }
  }
}

const deleteOffDaysData = (values) => {
  return {
    type: DELETE_OFFDAYS,
    payload: values
  }
}

export const deleteOffDays = (values) => {
  return async (dispatch) => {
    try {
     const JSONData = await dispatch(deleteUserOffDays(values));
      dispatch(deleteOffDaysData(JSONData));
      dispatch(dataSuccess())
    } catch(err) {
      dispatch(setOffDaysFailure(err));
      dispatch(dataFailure())
    }
  }
}

const requestOffDaysData = (values) => {
  return {
    type: REQUEST_OFFDAYS,
    payload: values
  }
}

export const requestOffDays = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(requestUserOffDays(values));
      dispatch(requestOffDaysData(JSONData));
    } catch(err) {
      dispatch(setOffDaysFailure(err));
    }
  }
}

const publishOffDaysData = (values) => {
  return {
    type: PUBLISH_OFFDAYS,
    payload: values
  }
}

export const publishOffDays = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(publishUserOffDays(values));
      dispatch(publishOffDaysData(JSONData));
    } catch(err) {
      dispatch(setOffDaysFailure(err));
    }
  }
}

const acceptOffDaysData = (values) => {
  return {
    type: ACCEPT_OFFDAYS,
    payload: values
  }
}

export const acceptOffDays = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(acceptUserOffDays(values));
      dispatch(acceptOffDaysData(JSONData));
    } catch(err) {
      dispatch(setOffDaysFailure(err));
    }
  }
}

const declineOffDaysData = (values) => {
  return {
    type: DECLINE_OFFDAYS,
    payload: values
  }
}

export const declineOffDays = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(declineUserOffDays(values));
      dispatch(declineOffDaysData(JSONData));
    } catch(err) {
      dispatch(setOffDaysFailure(err));
    }
  }
}

const setApprovementStateData = (values) => {
  return {
    type: SET_APPROVEMENT_STATE,
    payload: values
  }
}

export const resetApprovementState = (values) => {
  return async (dispatch) => {
    try {
      const JSONData = await dispatch(setApprovementState(values));
      dispatch(setApprovementStateData(JSONData));
    } catch(err) {
      dispatch(setOffDaysFailure(err));
    }
  }
}